<template>
	<Lottie :width="width" :height="height" :options="animationOptions" />
</template>
<script>
import Lottie from '@/assets/lottie/lottie.vue';
import BuilderLoaderAnimation from '@/components/Project/loader-animation.json';
export default {
	name: 'BuilderLoaderAnimation',
	components: { Lottie },
	props: {
		width: { type: Number, default: 70 },
		height: { type: Number, default: 70 },
	},
	computed: {
		animationOptions() {
			return { animationData: BuilderLoaderAnimation, loop: true, autoPlay: true };
		},
	},
};
</script>
<style scoped lang="scss"></style>
